import styled from "styled-components";
import InputField from "components/UI/InputField";
import DatePickerField from "components/UI/DatePickerField";
import Button from "@mui/material/Button";
import { defaultValueGet } from "common/parameters_common";
import VideoUpload from "./VideoUpload";
import VideoPlay from "../VideoPlay";
import { staticContentPath } from "common/static_content_common";

type VideoFormProps = {
  control: any;
  handleSubmit: Function;
  onSubmit: Function;
  reset: Function;
  defaultValues?: any;
  setValue?: any;
};

const VideoForm = ({
  control,
  onSubmit,
  handleSubmit,
  reset,
  defaultValues,
  setValue,
}: VideoFormProps) => {
  const datumDefault = defaultValueGet(defaultValues, "datum", new Date());
  const titleDefault = defaultValueGet(defaultValues, "title", "");
  const fileNameDefault = defaultValueGet(defaultValues, "fileName", "");

  const fileUploadHandle = (upRes: any) => {
    const fileName = upRes.files[0].filename;
    setValue("fileName", fileName);
    console.log("fileUploadHandle", upRes);
  };

  return (
    <DivForm>
      <form>
        <DivField>
          <DatePickerField
            control={control}
            name="datum"
            label="Datum"
            defaultValue={datumDefault}
          />
        </DivField>
        <DivField>
          <InputField
            name="title"
            control={control}
            label="Title"
            defaultValue={titleDefault}
          />
        </DivField>
        <DivField>
          {fileNameDefault && (
            <VideoPlay
              filePath={staticContentPath(fileNameDefault)}
              autoPlay={false}
              muted={true}
              width={500}
            />
          )}
        </DivField>
        <DivField>
          <VideoUpload
            fileUploadHandle={fileUploadHandle}
            fileNameDefault={fileNameDefault}
          />
        </DivField>

        <DivNav>
          <Button onClick={handleSubmit(onSubmit)} type="submit">
            Submit
          </Button>
          <Button onClick={() => reset()} variant={"outlined"}>
            Reset
          </Button>
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
`;

const DivNav = styled.div`
  margin-top: 2rem;
`;

export default VideoForm;
